import { isEmpty } from 'lodash';
export const fetchFeatureFlags = async (flags, bffUri, userId) => {
    if (!flags || isEmpty(flags))
        return {};
    const response = await fetch([bffUri, 'flags'].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            flags,
            ...(userId ? { userId } : {}),
        }),
        signal: AbortSignal.timeout(5000),
    });
    if (response.ok) {
        const { flags: respondFlags } = (await response.json());
        return respondFlags;
    }
    return {};
};
